import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useRef, useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon } from '@/components/ui/icon';
import { VolumeHighIcon, VolumeOffIcon } from '@/components/ui/icon/glyphs';
import { Panel } from '@/components/ui/panel';
import { logger } from '@/lib/telemetry/logger';
export function PartnerVideo(t0) {
  const $ = _c(18);
  const {
    url
  } = t0;
  const t = useTranslations("profile.partner");
  const videoRef = useRef(null);
  const [failed, setFailed] = useState(false);
  const [sound, setSound] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function fail() {
      setFailed(true);
      logger.warn("portfolio.partner_video.play_failed", {
        stage: "playback"
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const fail = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async function play(withSound, t3) {
      const reload = t3 === undefined ? false : t3;
      const video = videoRef.current;
      if (video === null) {
        return;
      }
      setFailed(false);
      if (reload) {
        video.load();
      }
      video.currentTime = 0;
      video.muted = !withSound;
      setSound(withSound);
      try {
        await video.play();
      } catch {
        setFailed(true);
        logger.warn("portfolio.partner_video.play_failed", {
          stage: "play_request"
        });
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const play = t2;
  let t3;
  if ($[2] !== sound) {
    t3 = function toggleSound() {
      if (!sound) {
        play(true);
        return;
      }
      const video_0 = videoRef.current;
      if (video_0 !== null) {
        video_0.muted = true;
      }
      setSound(false);
    };
    $[2] = sound;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const toggleSound = t3;
  const t4 = !sound;
  let t5;
  if ($[4] !== t) {
    t5 = t("introduction");
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== url) {
    t6 = <video ref={videoRef} src={url} autoPlay={true} muted={t4} playsInline={true} loop={true} preload="metadata" aria-label={t5} onError={fail} className="absolute inset-0 size-full object-cover" />;
    $[6] = t4;
    $[7] = t5;
    $[8] = url;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== failed || $[11] !== sound || $[12] !== t || $[13] !== toggleSound) {
    t7 = failed ? <div role="alert" className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-background-tertiary p-6 text-center text-caption text-foreground-secondary"><p>{t("video_error")}</p><AnimatedButton variant="secondary" onClick={() => void play(sound, true)}>{t("retry_video")}</AnimatedButton></div> : <button type="button" aria-pressed={sound} aria-label={sound ? t("mute") : t("unmute")} onClick={toggleSound} className="absolute inset-0 flex items-end justify-end p-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-border-primary"><span className="flex size-8 items-center justify-center rounded-full bg-surface-scrim-strong text-foreground-primary"><Icon icon={sound ? VolumeHighIcon : VolumeOffIcon} size={16} /></span></button>;
    $[10] = failed;
    $[11] = sound;
    $[12] = t;
    $[13] = toggleSound;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Panel className="relative min-w-0 shrink-0 overflow-hidden p-0 md:w-67" data-testid="partner-video"><div className="relative aspect-[9/13] max-h-[78vh] w-full bg-background-tertiary md:absolute md:inset-0 md:aspect-auto md:max-h-none">{t6}{t7}</div></Panel>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}